import { t } from '@lingui/macro'
import { Formik } from 'formik'
import { useTheme } from 'styled-components'

import { Checkbox } from '@/@bothrs-ui/web/components/forms/checkbox/Checkbox'
import { FlexColumn, Margin } from '@/@bothrs-ui/web/components/layout'
import { Modal } from '@/@bothrs-ui/web/components/modal/Modal'
import { Button } from '@/@bothrs-ui/web/components/primitives/button/Button'
import { P } from '@/@bothrs-ui/web/components/typography/Body'
import { H3 } from '@/@bothrs-ui/web/components/typography/Heading'

import type { InheritableModalProps } from '@/@bothrs-ui/web/components/modal/Modal.props'

type RemecareWarningModalProps = InheritableModalProps & {
  onAction: (neverShow: boolean) => void
}

type FormValues = { neverShow: boolean }
const initialvalues: FormValues = { neverShow: false }

export const RemecareWarningModal = ({ onAction, ...props }: RemecareWarningModalProps) => {
  const theme = useTheme()

  const handleSubmit = (values: FormValues) => {
    onAction(values.neverShow)
  }

  return (
    <Modal {...props}>
      <FlexColumn alignItems='center' gap={16}>
        <img style={{ width: 32, height: 32 }} src='/img/svg/remecare.svg' alt='' />
        <Formik initialValues={initialvalues} onSubmit={handleSubmit}>
          {({ values, submitForm }) => (
            <>
              <H3 textAlign='center' color={theme.Colors.Neutrals.Darkest}>
                {t({
                  id: 'timeline.remecare-warning-modal.title',
                  message: 'Je wordt zo doorgestuurd naar de Remecare app',
                })}
              </H3>

              <P type='BodyLargeRegular' textAlign='center' color={theme.Colors.Neutrals.Darker}>
                {t({
                  id: 'timeline.remecare-warning-modal.description',
                  message: 'Remecare taken kan je in MijnZiekenhuis wel bekijken maar niet voltooien.',
                })}
              </P>

              <Checkbox
                type='checkbox'
                id={'neverShow'}
                name={`neverShow`}
                label={t({
                  id: 'timeline.remecare-warning-modal.never-show',
                  message: 'Nooit meer tonen',
                })}
                checked={values.neverShow}
              />

              <Margin mt={theme.UI.Spacing.Space2} />
              <Button variant='Primary' type='submit' onClick={submitForm}>
                {t({
                  id: 'timeline.remecare-warning-modal.continue',
                  message: 'Voltooi in Remecare app',
                })}
              </Button>
              <Button variant='Tertiary' onClick={props.onClose}>
                {t({
                  id: 'profile.account-settings.cancel',
                  message: 'Blijf in MijnZiekenhuis',
                })}
              </Button>
            </>
          )}
        </Formik>
      </FlexColumn>
    </Modal>
  )
}
